
import { Component, Vue, Watch } from 'vue-property-decorator'
import { UserModel } from '@/store/models/UserModel'
import STextField from '@/components/STextField.vue'
import SButton from '@/components/SButton.vue'
import eventBus from '@/plugins/eventBus'
@Component({
  components: { STextField, SButton },
})
export default class RegisterModal extends Vue {
  request: any = {
    first_name: '',
    last_name: '',
    email: '',
    password: '',
    password_confirmation: '',
    phone: '',
    mobile_phone: '',
    birthday: '',
    provider: 'local',
  }

  registerStatus: number = 0
  error: any = {}
  disableRegisterBtn: boolean = false

  showPassword = false
  showConfirmPassword = false
  user: UserModel = UserModel.getInstance()

  positiveDecimalKeydown(event) {
    const key = event.key

    if (key !== 'Backspace' && key !== 'Tab' && !/[\d+]/.test(key)) {
      event.preventDefault() // prevent non-numeric characters from being entered
    }
  }

  register() {
    if (this.request.first_name.length < 3) {
      alert('Emri duhet me mbi 3 karaktere')
      return
    }
    if (this.request.last_name.length < 3) {
      alert('Mbiemri duhet me mbi 3 karaktere')
      return
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.request.email)) {
      alert('Email nuk është në formatin e duhur')
      return
    }

    if (this.request.password.length < 8) {
      alert('Password duhet me mbi 8 karaktere')
      return
    }

    if (this.request.password !== this.request.password_confirmation) {
      alert('Password-et nuk përputhen.')
      return
    }
    if (!/^([+])(355)\d{9}$/.test(this.request.mobile_phone)) {
      alert('Nr. i tel duhet të fillojë me +355 dhe të jetë 13 karaktere')
      return
    }
    this.disableRegisterBtn = true
    this.user.register(
      this.request,
      () => {
        this.disableRegisterBtn = false
      },
      () => {
        this.disableRegisterBtn = false
      }
    )
    if (this.registerStatus === 200) {
      this.disableRegisterBtn = false
      this.$modal.hide('register')
      return
    }
    // this.validations()
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword
  }
  toggleConfirmPasswordVisibility() {
    this.showConfirmPassword = !this.showConfirmPassword
  }

  // validations() {
  //   if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.request.email)) {
  //     alert('Email nuk eshte ne formation e duhur')
  //     return
  //   }
  //   if (this.request.password.length < 8) {
  //     alert('Password duhet me mbi 8 karaktere')
  //     return
  //   }
  //   if (this.request.password !== this.request.password_confirmation) {
  //     alert('Password-et Nuk perputhen.')
  //     return
  //   }
  //   if (this.request.mobile_phone.length < 13) {
  //     alert('Numri i telefonit duhet 13 shifra')
  //     return
  //   }
  // }

  registerWithFacebook() {
    this.user.registerWithFacebook()
    this.$modal.hide('register')
  }

  registerWithGmail() {
    this.user.registerWithGmail()
    this.$modal.hide('register')
  }
  mounted() {
    eventBus.$on(`error:register`, (error: object) => {
      this.error = error
    })
    eventBus.$on(`user:register`, (status: number) => {
      this.registerStatus = status
    })
  }
  @Watch('registerStatus')
  onRegisterStatusChange() {
    this.$modal.hide('register')
  }
}
